<template>
  <div class="container">
    <md-card class="dash-content">
      <div class="header-wrapper">
        <PageHeader title="Manage Faq Categories" />
        <div class="loader">
          <Wave
            v-if="loading || updating || deleting"
            width="50px"
            color="#d9534f"
          />
        </div>
        <div>
          <md-button class="md-primary mx-4" :to="{ name: 'Faq' }">
            Faq
          </md-button>
          <md-button class="md-primary" :to="{ name: 'Faq Category Create' }">
            Add New Category
          </md-button>
        </div>
      </div>
      <md-table
        v-model="categories.mdData"
        md-card
        md-sort="title"
        md-sort-order="asc"
      >
        <!-- <md-table-toolbar class="mb-4">
          <div class="md-toolbar-section-start">
            <md-button class="md-primary button-icon" disabled>
              Download Excel
              <img src="@/assets/svg/excel.svg" />
            </md-button>
          </div>
          <div class="toolbar-filter-wrapper">
            <md-field md-clearable class="md-toolbar-section-end">
              <md-icon>search</md-icon>
              <md-input placeholder="Search by name..." v-model="search" />
            </md-field>
          </div>
        </md-table-toolbar> -->
        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell md-label="S/N">{{ item.id }}</md-table-cell>
          <md-table-cell md-label="Title">{{ item.title }}</md-table-cell>
          <md-table-cell md-label="Create At">{{
            item.created_at || formatDate
          }}</md-table-cell>

          <md-table-cell md-label="Actions">
            <div class="table-actions">
              <md-button
                :disabled="updating || deleting"
                md-menu-trigger
                class="bggreen"
                :to="{ name: 'Faq Category Edit', params: { id: item.id } }"
                >Edit</md-button
              >
              <md-button
                :disabled="updating"
                @click="remove(item.id)"
                class="bggreen md-icon-button md-raised btn-icon"
                ><i class="material-icons">delete</i></md-button
              >
            </div>
          </md-table-cell>
        </md-table-row>
      </md-table>
      <span v-if="loading" class="b-loading">Loading...</span>
      <pagination
        v-model="categories.mdPage"
        :records="categories.mdCount"
        :per-page="categories.mdPerPage"
        @paginate="updatePagination"
      />
    </md-card>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapGetters } = createNamespacedHelpers("faq");
export default {
  name: "User",
  data() {
    return {
      updating: false,
      deleting: false,
      search: ""
    };
  },
  watch: {
    search(val) {
      this.waitForIt(val);
    }
  },

  methods: {
    ...mapActions(["getCategories", "deleteCategory"]),
    async updatePagination(page) {
      let data = { page };
      if (this.search) data.keyword = this.search;
      await this.getCategories(data);
    },
    async submitSearch() {
      await this.getCategories({ keyword: this.search });
    },

    waitForIt(val) {
      if (this.time) {
        clearTimeout(this.time);
      }
      this.time = setTimeout(() => this.submitSearch(val), 1000);
    },
    async remove(id) {
      const conf = confirm("Are you sure?");
      if (conf) {
        this.deleting = true;
        await this.deleteCategory(id);
        this.getCategories();
        this.deleting = false;
        this.toast("success", "Category deleted");
      }
    }
  },
  created() {},
  mounted() {
    this.getCategories();
  },
  computed: {
    ...mapGetters(["categories", "loading"]),
    hasPermission() {
      return this.$store.getters["auth/has_module_permission"]("crud");
    }
  }
};
</script>

<style lang="scss" scoped>
.md-table-cell {
  width: 0% !important;
  padding: 0rem 0.8rem;
}

.md-table + .md-table {
  margin-top: 16px;

  thead {
    height: 50px !important;
  }
}
</style>
